<div class="wizard-control">
    <div *ngFor="let step of steps" class="step" (click)="selectStep(step)" [class.active]="step.active" [class.completed]="step.completed">
        <span class="step-icon">{{getStepIndex(step)}}</span> {{step.title}}
    </div>
</div>

<div class="wizard-container">
    <ng-content></ng-content>
</div>

<div class="wizard-buttons">
    <div class="action-bar">
        <button type="button" class="button-cancel" (click)="previousStep()" *ngIf="!isFirstStep() && !isDisallowingPrevious()">
            <i class="fa-solid fa-circle-chevron-left"></i> Previous
        </button>
        <button type="button" class="button" (click)="nextStep()" [disabled]="isNextDisabled()" [class.disabled]="isNextDisabled()" *ngIf="!isLastStep()">
            Next <i class="fa-solid fa-circle-chevron-right"></i>
        </button>
        <button type="button" class="button" (click)="finish()" [disabled]="isFinishing" [class.disabled]="isFinishing" *ngIf="isLastStep()">
            <ng-container *ngIf="!isFinishing">Finish <i class="fa-solid fa-table-list"></i></ng-container>
            <ng-container *ngIf="isFinishing"><i class="fa-solid fa-spinner fa-spin"></i> Finishing...</ng-container>
        </button>
    </div>
</div>